var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTriangleGradientShadow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6073_35113)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 24.3694C30.995 24.6086 30.9381 24.8505 30.824 25.0787L24.1574 38.412C23.7457 39.2353 22.7446 39.569 21.9213 39.1574C21.098 38.7457 20.7643 37.7446 21.176 36.9213L27.8426 23.588C28.2543 22.7647 29.2554 22.431 30.0787 22.8426C30.6516 23.1291 30.9875 23.7011 31 24.2999C31.0125 23.7011 31.3484 23.1291 31.9213 22.8426C32.7446 22.431 33.7457 22.7647 34.1574 23.588L40.824 36.9213C41.2357 37.7446 40.902 38.7457 40.0787 39.1574C39.2554 39.569 38.2543 39.2353 37.8426 38.412L31.176 25.0787C31.0619 24.8505 31.005 24.6086 31 24.3694ZM22.6667 41C22.6667 40.0795 23.4129 39.3333 24.3333 39.3333H37.6667C38.5871 39.3333 39.3333 40.0795 39.3333 41C39.3333 41.9205 38.5871 42.6667 37.6667 42.6667H24.3333C23.4129 42.6667 22.6667 41.9205 22.6667 41Z",
    fill: "url(#paint0_linear_6073_35113)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3333 21C29.3333 21.9205 30.0795 22.6667 31 22.6667C31.9205 22.6667 32.6667 21.9205 32.6667 21C32.6667 20.0795 31.9205 19.3333 31 19.3333C30.0795 19.3333 29.3333 20.0795 29.3333 21ZM31 16C28.2386 16 26 18.2386 26 21C26 23.7614 28.2386 26 31 26C33.7614 26 36 23.7614 36 21C36 18.2386 33.7614 16 31 16ZM19.3333 41C19.3333 41.9205 20.0795 42.6667 21 42.6667C21.9205 42.6667 22.6667 41.9205 22.6667 41C22.6667 40.0795 21.9205 39.3333 21 39.3333C20.0795 39.3333 19.3333 40.0795 19.3333 41ZM21 36C18.2386 36 16 38.2386 16 41C16 43.7614 18.2386 46 21 46C23.7614 46 26 43.7614 26 41C26 38.2386 23.7614 36 21 36ZM41 42.6667C40.0795 42.6667 39.3333 41.9205 39.3333 41C39.3333 40.0795 40.0795 39.3333 41 39.3333C41.9205 39.3333 42.6667 40.0795 42.6667 41C42.6667 41.9205 41.9205 42.6667 41 42.6667ZM36 41C36 38.2386 38.2386 36 41 36C43.7614 36 46 38.2386 46 41C46 43.7614 43.7614 46 41 46C38.2386 46 36 43.7614 36 41Z",
    fill: "url(#paint1_linear_6073_35113)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6073_35113",
    x: -5,
    y: -5,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.192157 0 0 0 0 0.847059 0 0 0 0 0.74902 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6073_35113"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6073_35113",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6073_35113",
    x1: 19.6429,
    y1: 12.5,
    x2: 42.4328,
    y2: 59.5535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31D8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0965F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6073_35113",
    x1: 19.6429,
    y1: 12.5,
    x2: 42.4328,
    y2: 59.5535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31D8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0965F1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleGradientShadow);
export default __webpack_public_path__ + "static/media/triangle-gradient-shadow.cac87e13b31c122fc38468661d18e68d.svg";
export { ForwardRef as ReactComponent };